import { queryOptions } from '@tanstack/react-query'
import {
  getPaginatedActivityLogLists,
  getPaginatedProgramUserLists,
  PaginatedAcitivityLogLists,
  PaginatedUserLists,
  UserDetails,
} from '@/queries/users/requests.ts'
import { CustomQueryOptions } from '@/common/types_and_interfaces.ts'
import { getUserDetail } from './requests.ts'

const UserListQueryKeys = {
  list_all: ['user_list'],
  list_by_program: (programId?: number) => [
    ...UserListQueryKeys.list_all,
    programId,
  ],
  paginate_by_program: (
    recordsPerPage: number,
    currentPage: number,
    programId?: number,
    search?: string | undefined,
    status?: number | null,
    roles?: string[]
  ) => [
    ...UserListQueryKeys.list_all,
    programId,
    recordsPerPage,
    currentPage,
    search,
    status,
    roles,
  ],
  details: (user_id: number) => ['user_detail', user_id],
} as const
export class UserListQueries {
  static getPaginatedListByProgramId(
    recordsPerPage: number,
    currentPage: number,
    programId?: number,
    search?: string | '',
    options: CustomQueryOptions<PaginatedUserLists> = {},
    status?: number | null,
    roles?: string[]
  ) {
    return queryOptions({
      queryKey: UserListQueryKeys.paginate_by_program(
        recordsPerPage,
        currentPage,
        programId,
        search,
        status,
        roles
      ),
      queryFn: () =>
        getPaginatedProgramUserLists(
          currentPage,
          programId,
          recordsPerPage,
          search,
          status,
          roles
        ),
      ...options,
    })
  }

  public static getUserById(
    userId?: string,
    options: CustomQueryOptions<UserDetails> = {}
  ) {
    const userIdNumber = userId ? parseInt(userId, 10) : undefined
    return queryOptions({
      queryKey: UserListQueryKeys.details(userIdNumber ?? 0),
      queryFn: () => getUserDetail(userId ?? ''),
      enabled: !!userId,
      ...options,
    })
  }
}

const ActivityLogListQueryKeys = {
  list_all: ['activity_logs'],
  paginate_by_user: (
    recordsPerPage: number,
    currentPage: number,
    userId?: number,
    userType?: number | undefined,
    search?: string | '',
    selectedFilter?: string
  ) => [
    ...ActivityLogListQueryKeys.list_all,
    userId,
    userType,
    recordsPerPage,
    currentPage,
    search,
    selectedFilter,
  ],
} as const
export class ActivityLogListQueries {
  static getPaginatedActivityLogByUserId(
    recordsPerPage: number,
    currentPage: number,
    userId?: number,
    userType?: number | undefined,
    search?: string | '',
    selectedFilter?: string,
    options: CustomQueryOptions<PaginatedAcitivityLogLists> = {}
  ) {
    return queryOptions({
      queryKey: ActivityLogListQueryKeys.paginate_by_user(
        recordsPerPage,
        currentPage,
        userId,
        userType,
        search,
        selectedFilter
      ),
      queryFn: () =>
        getPaginatedActivityLogLists(
          currentPage,
          userId,
          userType,
          recordsPerPage,
          search,
          selectedFilter
        ),
      ...options,
    })
  }
}
